import React from 'react';
import { GlassCard } from '../components/GlassCard';
import SafeIcon from '../common/SafeIcon';
import { FiSave, FiMail, FiSlack, FiDatabase } from 'react-icons/fi';

export const Settings = () => {
  return (
    <div className="space-y-6 max-w-4xl mx-auto">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Platform Settings</h1>
        <p className="text-slate-400 mt-1">Configure monitoring parameters and integrations.</p>
      </div>

      <div className="space-y-6">
        <GlassCard>
          <h3 className="text-lg font-medium mb-4 flex items-center gap-2">
            <SafeIcon icon={FiDatabase} />
            Data Retention
          </h3>
          <div className="space-y-4">
            <div>
              <label className="block text-sm text-slate-400 mb-1">Alert History Storage</label>
              <select className="w-full bg-black/50 border border-white/10 rounded-lg px-4 py-2 text-sm text-slate-200 focus:outline-none focus:border-emerald-500/50">
                <option>30 Days</option>
                <option>90 Days</option>
                <option>1 Year</option>
              </select>
            </div>
            <p className="text-xs text-slate-500">Longer retention periods may affect dashboard performance.</p>
          </div>
        </GlassCard>

        <GlassCard>
          <h3 className="text-lg font-medium mb-4 flex items-center gap-2">
            <SafeIcon icon={FiMail} />
            Notification Channels
          </h3>
          <div className="space-y-4">
            <div className="flex items-center justify-between p-3 bg-white/5 rounded-lg border border-white/5">
              <div className="flex items-center gap-3">
                <div className="p-2 bg-blue-500/10 text-blue-400 rounded">
                  <SafeIcon icon={FiMail} />
                </div>
                <div>
                  <p className="font-medium text-sm">Email Digest</p>
                  <p className="text-xs text-slate-500">Daily summary of new alerts</p>
                </div>
              </div>
              <label className="relative inline-flex items-center cursor-pointer">
                <input type="checkbox" className="sr-only peer" defaultChecked />
                <div className="w-9 h-5 bg-slate-700 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-emerald-500"></div>
              </label>
            </div>

            <div className="flex items-center justify-between p-3 bg-white/5 rounded-lg border border-white/5">
              <div className="flex items-center gap-3">
                <div className="p-2 bg-[#E01E5A]/10 text-[#E01E5A] rounded">
                  <SafeIcon icon={FiSlack} />
                </div>
                <div>
                  <p className="font-medium text-sm">Slack Webhook</p>
                  <p className="text-xs text-slate-500">Real-time critical alerts</p>
                </div>
              </div>
              <label className="relative inline-flex items-center cursor-pointer">
                <input type="checkbox" className="sr-only peer" />
                <div className="w-9 h-5 bg-slate-700 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-emerald-500"></div>
              </label>
            </div>
          </div>
        </GlassCard>

        <div className="flex justify-end">
          <button className="flex items-center gap-2 bg-emerald-500 hover:bg-emerald-600 text-black px-6 py-2 rounded-lg text-sm font-semibold transition-colors">
            <SafeIcon icon={FiSave} />
            Save Configuration
          </button>
        </div>
      </div>
    </div>
  );
};